import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveAttributeScope } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveAttributeScopeActivity = ({ values }: IProjectActivity<IProjectActivityRemoveAttributeScope>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveAttributeScope')}
      <b>{values.scope}</b> {t('activity_description_common.from')} {t('activity_description_common.attribute')} <b>{values.attribute}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
